import { render, staticRenderFns } from "./Purchased2.vue?vue&type=template&id=463bd428&scoped=true&"
import script from "./Purchased2.vue?vue&type=script&lang=js&"
export * from "./Purchased2.vue?vue&type=script&lang=js&"
import style0 from "./Purchased2.vue?vue&type=style&index=0&id=463bd428&prod&lang=scss&scoped=true&"
import style1 from "./Purchased2.vue?vue&type=style&index=1&id=463bd428&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463bd428",
  null
  
)

export default component.exports